import { render } from "./TemplateGroup.vue?vue&type=template&id=2cefce15&scoped=true"
import script from "./TemplateGroup.vue?vue&type=script&lang=js"
export * from "./TemplateGroup.vue?vue&type=script&lang=js"

import "./TemplateGroup.vue?vue&type=style&index=0&id=2cefce15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cefce15"]])

export default __exports__